export function formatDate(dateString) {
  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day}.${month}.${year} / ${hours}:${minutes}`;
}

export const daysToSeconds = (expiresIn) => {
  const dayMatch = expiresIn.match(/^(\d+)d$/);
  if (dayMatch) {
    const days = parseInt(dayMatch[1], 10);
    return days * 24 * 60 * 60;
  }
  return 7 * 24 * 60 * 60;
};
